import React from 'react';
import { Button, Card, CardActions, CardContent, CardHeader, Divider, Modal, Snackbar } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { connect } from 'react-redux';
import Alert from 'src/components/Alert';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));
function FgsCallSondaj({ open, onClose, FisNo, Telefon, Telefon2, className }) {
  const classes = useStyles();
  const [LoadingControl, setLoadingControl] = useState(false);
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: "0", ErrorDescription: "İşleminiz başarı ile gerçekleştirildi." });
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  let AramaData = [];





  if (!open) {
    return null;
  }



  const handleFgsAramaYap = (_event, Telefon, _tip, _FisNo) => {



    var Uyari = "";
    Uyari += "0" + Telefon + " numaralı telefonuna bağlayacağım. Aramayı başlatmamı ister misin?";
    var UyariAlert = "0" + Telefon + " numaralı telefonu için arama başlatıldı.";

    const confirmation = window.confirm(Uyari)
    if (!confirmation) {
      return;
    }


    setresponseMessage({ ErrorCode: "0", ErrorDescription: "Arama Başarılı!..." });
    setUyariTip("success");
    setUyari(true);
    setLoadingControl(false);
    const phoneNumber = "0" + Telefon;
    window.open(`tel:${phoneNumber}`, '_self');
    alert(UyariAlert);
    return;



  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const getTitle = () => {
    return "";
    // return event[0]?.FisNo + " " + event[0]?.Musteri + " " + event[0]?.BasvuruNedeni;
  }

  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card className={clsx(classes.root, className)} >
        <form>
          <CardHeader title={getTitle(AramaData)} />
          <Divider />
          <CardContent>
            {
              LoadingControl ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
                : <div></div>
            }
            <div>
              <div className={classes.wrapper}>
                {
                  Telefon !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, Telefon, 1, FisNo, "", Telefon)}
                      endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                      {Telefon}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  Telefon2 !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, Telefon2, 2, FisNo, "", Telefon2)}
                      endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
                      {Telefon2}
                    </Button>
                    : <div></div>
                }
              </div>


            </div>
            <Snackbar open={uyari} onClose={uyariKapat} autoHideDuration={5000}>
              <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
            </Snackbar>
          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="secondary"
              onClick={onClose}>
              Kapat
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

FgsCallSondaj.propTypes = {
  className: PropTypes.string,
  FisNo: PropTypes.string,
  Telefon: PropTypes.string,
  Telefon2: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

FgsCallSondaj.defaultProps = {
  open: false,
  onClose: () => { }
};

export default connect(
  state => ({ tasks: state.tasks1 })
)(FgsCallSondaj);
